import React from "react";

import Link from "../Link/Link";

import "./ImageThumbnail.scss";

const ImageThumbnail = ({ image, url, uiVariant }) => {
  return (
    <div className="image-thumbnail">
      <Link to="#">
        <div
          className="image-container"
          style={{
            backgroundImage: `url(${image})`,
            borderRadius: uiVariant === "1" ? 12 : 0,
          }}
        ></div>
      </Link>
    </div>
  );
};

export default ImageThumbnail;
